export var ACTION;
(function (ACTION) {
    ACTION["CHANGE_INPUT"] = "CHANGE_INPUT";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["CHECK_LIMIT"] = "CHECK_LIMIT";
    ACTION["ON_CHANGE_DIMENSION"] = "ON_CHANGE_DIMENSION";
    ACTION["IS_RESEND_OTP"] = "IS_RESEND_OTP";
})(ACTION || (ACTION = {}));
// export type TestActionPayload = {}
